$(function () {
  aboutUs();
  tensVision();
  tensVisionInner();
});
$(window).resize(function () {
  aboutUs();
});

/**
 *  关于天狮
 */
function aboutUs() {
  $(".abIn dl dd .abIn-info").css("height", $(".abIn dl dt img").height());

  $(".bg-fixed .container").css("width", $(".aboutUs .bg-fixed").width());

  var a = $(".abLast img").height();
  var b = $(".abLast img").width();

  $(document).ready(function () {
    $(".abLast li").css("height", a);

    $(".abLast .info").css("height", a);
    $(".abLast .info").css("width", b);

    $(".abLast li.on .info").css("height", a);
    $(".abLast li.on .info").css("width", b);
  });

  var _width = $(window).width();
  if (_width > 1024) {
    $(document).ready(function () {
      $(".abLast li").css("height", a);

      $(".abLast .info").css("height", a);
      $(".abLast .info").css("width", b);

      $(".abLast li.on .info").css("height", a - 80);
      $(".abLast li.on .info").css("width", b - 80);
    });

    $(".abLast li").mouseenter(function (e) {
      if ($(this).hasClass("on")) {
      } else {
        $(this).parents(".abLast").find("li.on .info").css("height", a);
        $(this).parents(".abLast").find("li.on .info").css("width", b);
        $(this).parents(".abLast").find("li.on").removeClass("on");

        $(this).addClass("on");
        $(this)
          .find(".info")
          .css("height", a - 80);
        $(this)
          .find(".info")
          .css("width", b - 80);
      }
    });
  } else {
    $(".abLast li").mouseenter(function (e) {
      if ($(this).hasClass("on")) {
      } else {
        $(this).parents(".abLast").find("li.on .info").css("height", "100%");
        $(this).parents(".abLast").find("li.on .info").css("width", "100%");
        $(this).parents(".abLast").find("li.on").removeClass("on");

        $(this).addClass("on");
        $(this).find(".info").css("height", "100%");
        $(this).find(".info").css("width", "100%");
      }
    });
  }
}

/**
 *  天师视界
 */
function tensVision() {
  $(".select-Div .select-show").click(function () {
    // $(this).parents(".select-Div").find('.select-list').show();
    $(this).next().slideToggle();
  });

  $(".select-list dd a").click(function () {
    var txtSl = $(this).text();
    $(this).parents(".select-Div").find(".select-show span").text(txtSl);
    $(this).parents(".select-Div").find(".select-list").hide();
  });
}

function tensVisionInner() {
  var visionImg = $(".tensVisionInner .group-img img");
  visionImg.load(function () {
    $("#innerVideo").css(
      "height",
      $(".tensVisionInner .group-img img").height()
    );
  });

  function playSec4video() {
    var videourl = $(".video-play-btn").attr("videourl");
    var videobg = $(".video-play-btn").attr("videobg");
    // sec4Video = VideoPaly('sec-4-player', './static/media/video4.mp4', './static/images/video4.png');
    sec4Video = VideoPaly("sec-4-player", videourl, videobg);
    sec4Video.onReady = function (e) {
      console.log(sec4Video);
      var st = sec4Video.getState();
      if (sec4Video.getState() != "PLAYING") {
        isPlaying = true;
        sec4Video.play();
      }
    };
  }

  $(".tensVisionInner .video-play-btn").click(function (e) {
    $("#group-cont").addClass("playing");
    setTimeout(function () {
      playSec4video();
    }, 600);

    $(this).parents("#group-cont").hide();
    $("#sec-4-player").css(
      "height",
      $(".tensVisionInner .group-img img").height()
    );
  });

  function VideoPaly(idName, videoUrl, imgUrl) {
    var playerh = $("#innerVideo").height();
    var player = jwplayer(idName).setup({
      flashplayer: "s3_source/video/jwplayer.flash.swf",
      file: videoUrl,
      image: imgUrl,
      repeat: false,
      // "controls":false,
      // "autostart": true,
      mute: true,
      stretching: "fill",
      width: "100%",
      height: playerh,
    });
    return player;
    //console.log(player);
  }
}
